import { FC, useEffect, useState } from 'react'
import './Onboarding.scss'
import React from 'react'

type OnboardingQuestion = {
  questionId: string;
  title: string;
  options: string[];
  subTitle: string;
  answer?: string | string[] | null;
}

type SingleSelectProps = {
  data: OnboardingQuestion;
  setIsDisable: (value: boolean) => void;
  onSubmit: (answer: string | null | Record<string, string>) => void;
}

const SingleSelect: FC<SingleSelectProps> = ({ data, setIsDisable, onSubmit }) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(data?.answer as string ?? null);

  const handleChange = (option: string) => {
    setSelectedOption(option);
    setIsDisable(false)
    onSubmit({ [`${data.questionId}`]: option })
  };

  const isMultipleColumn = data.options.length > 5;

  useEffect(() => {
    if (selectedOption) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.answer]);

  return (
    <>
      <div className='fw-boldest fs-3'>{data.title}</div>
      <div className='onboarding-description'>{data.subTitle}</div>
      <div className={`gap-4 mt-10 ${isMultipleColumn ? 'd-flex flex-wrap' : ''}`}>
        {data.options.map((opt) => (
          <div
            key={opt}
            className='form-check form-check-custom form-check-solid mb-5'
            style={isMultipleColumn ? { width: 'calc(50% - 1rem)' } : {}}
            onChange={() => handleChange(opt)}
          >
            <input
              id={opt}
              className='form-check-input widget-9-check radio-input'
              type='checkbox'
              value={opt}
              checked={selectedOption === opt}
              onChange={() => handleChange(opt)}
            />
            <label className='form-check-label option-label' htmlFor={opt}>
              {opt}
            </label>
          </div>
        ))}
      </div>
    </>
  );
};

export default React.memo(SingleSelect)
